import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Image from './Image';
import appStyles from '../../../../config/appStyles.js';
import { useStores } from '../../stores/index.js';
import { detectAlpha2Country } from '../../../../utils/country.js';
import { countryCodes } from '../../../../stores/Constants.js';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => appStyles.logo(theme));

const Logo = ({ className }) => {
  const history = useHistory();
  const classes = useStyles();
  const { userStore } = useStores();
  const { isLogged } = userStore;
  let logoName = '';
  let urlLink = '';

  const alpha2Country = detectAlpha2Country();

  switch (alpha2Country) {
    case countryCodes.fr:
      logoName = 'logo_white_altaya';
      urlLink = 'https://www.altaya.fr/';
      break;
    case countryCodes.be:
      logoName = 'logo_white_altaya';
      urlLink = 'https://www.altaya.be/';
      break;
    case countryCodes.es:
      logoName = 'logo_white_planeta';
      urlLink = 'https://www.planetadeagostini.es/';
      break;
    case countryCodes.ar:
      logoName = 'logo_white_planeta';
      urlLink = 'https://www.planetadeagostini.es/';
      break;
    case countryCodes.mx:
      logoName = 'logo_white_planeta';
      urlLink = 'https://www.planetadeagostini.es/';
      break;
    case countryCodes.pt:
      logoName = 'logo_white_planeta';
      urlLink = 'https://www.planetadeagostini.es/';
      break;
    default:
      logoName = 'logo_white';
      urlLink = 'https://www.deagostini.com/';
  }

  return (
    <Image
      className={clsx(className, classes.logo)}
      name={logoName}
      onClick={() => {
        if (isLogged) {
          history.push(`/myarea/dashboard`);
        } else {
          window.location.href = alpha2Country
            ? `${urlLink}${alpha2Country.toLowerCase()}`
            : urlLink;
        }
      }}
    />
  );
};

export default Logo;
